import {
	ApplicationConfig,
	LOCALE_ID,
	provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.router';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import {
	getAnalytics,
	provideAnalytics,
	ScreenTrackingService,
	UserTrackingService,
} from '@angular/fire/analytics';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { getPerformance, providePerformance } from '@angular/fire/performance';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { TCBTheme } from './themes/tcb-theme';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideServiceWorker } from '@angular/service-worker';
import { DialogService } from 'primeng/dynamicdialog';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import { customPrimeNGlocale } from '@utils/constants.utils';
import { environment } from '@environments/environment';
import {
	initializeAppCheck,
	ReCaptchaEnterpriseProvider,
	provideAppCheck,
} from '@angular/fire/app-check';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appCheckInterceptor } from '@interceptors/appcheck.interceptor';

registerLocaleData(localeEsAr, 'es-AR');

if (environment.firebase.dt) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = environment.firebase.dt;
}

const firebaseApp = initializeApp(environment.firebase.config);

export const appConfig: ApplicationConfig = {
	providers: [
		{ provide: LOCALE_ID, useValue: 'es-AR' },
		provideAnimationsAsync(),
		providePrimeNG({
			theme: {
				preset: TCBTheme,
				options: {
					darkModeSelector: false,
					cssLayer: {
						name: 'primeng',
						order: 'tailwind-base, primeng, tailwind-utilities',
					},
				},
			},
			translation: customPrimeNGlocale,
		}),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideFirebaseApp(() => firebaseApp),
		provideAppCheck(() => {
			const provider = new ReCaptchaEnterpriseProvider(
				environment.firebase.recaptchaKey
			);
			return initializeAppCheck(firebaseApp, {
				provider,
				isTokenAutoRefreshEnabled: true,
			});
		}),
		provideHttpClient(withInterceptors([appCheckInterceptor])),
		provideAuth(() => getAuth()),
		provideAnalytics(() => getAnalytics()),
		provideFirestore(() => getFirestore()),
		provideFunctions(() => getFunctions()),
		provideMessaging(() => getMessaging()),
		providePerformance(() => getPerformance()),
		provideStorage(() => getStorage()),
		provideAnimationsAsync(),
		provideServiceWorker('combined-sw.js', { enabled: true }),
		ScreenTrackingService,
		UserTrackingService,
		ConfirmationService,
		MessageService,
		DialogService,
	],
};
